// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stripe_payment.css */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.payment-page-wrapper {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 30px 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

.payment-container-main {
  max-width: 1400px;
  margin: 0 auto;
}

.payment-header {
  background: white;
  padding: 20px 30px;
  border-radius: 8px;
  margin-bottom: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.payment-header h1 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.payment-content-wrapper {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 25px;
  align-items: start;
}

/* Order Summary Card */
.order-summary-section {
  background: white;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 20px;
}

.order-summary-section h2 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f5f5f5;
}

.ad-info-box {
  background: #fff8f0;
  border: 1px solid #ffe4cc;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 20px;
}

.ad-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.ad-info-row:last-child {
  margin-bottom: 0;
}

.info-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.info-value {
  font-size: 15px;
  color: #333;
  font-weight: 600;
}

.price-display-box {
  background: linear-gradient(135deg, #ff6b00 0%, #ff8c3a 100%);
  border-radius: 6px;
  padding: 25px;
  text-align: center;
  margin-top: 20px;
  color: white;
}

.price-label-text {
  font-size: 14px;
  opacity: 0.95;
  margin-bottom: 8px;
  font-weight: 500;
}

.price-amount-display {
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 5px;
}

.price-subtext {
  font-size: 13px;
  opacity: 0.9;
}

.divider-line {
  height: 1px;
  background: #e5e5e5;
  margin: 20px 0;
}

.user-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
}

.user-info-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.user-info-value {
  font-size: 14px;
  color: #333;
  font-weight: 600;
}

/* Payment Form Card */
.payment-form-section {
  background: white;
  border-radius: 8px;
  padding: 35px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.payment-form-section h3 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f5f5f5;
}

.secure-payment-badge {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px;
  background: #f0fdf4;
  border: 1px solid #d1fae5;
  border-radius: 6px;
  margin-bottom: 25px;
}

.secure-payment-badge svg {
  width: 24px;
  height: 24px;
  fill: #10b981;
  flex-shrink: 0;
}

.secure-payment-badge p {
  font-size: 13px;
  color: #047857;
  margin: 0;
  line-height: 1.5;
}

.stripe-element-container {
  margin-bottom: 20px;
}

.error-message-box {
  margin-top: 15px;
  padding: 12px 15px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  color: #dc2626;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.pay-button-submit {
  width: 100%;
  background: linear-gradient(135deg, #ff6b00 0%, #ff8c3a 100%);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 25px;
}

.pay-button-submit:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(255, 107, 0, 0.35);
}

.pay-button-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.pay-button-submit .button-icon {
  width: 20px;
  height: 20px;
  fill: white;
}

.security-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;
}

.security-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #666;
}

.security-item svg {
  width: 16px;
  height: 16px;
  fill: #10b981;
}

.loading-spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 350px;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .payment-content-wrapper {
    grid-template-columns: 1fr;
  }
  
  .order-summary-section {
    position: static;
  }
}

@media (max-width: 640px) {
  .payment-page-wrapper {
    padding: 20px 10px;
  }
  
  .payment-header {
    padding: 15px 20px;
  }
  
  .payment-header h1 {
    font-size: 20px;
  }
  
  .order-summary-section,
  .payment-form-section {
    padding: 20px;
  }
  
  .price-amount-display {
    font-size: 36px;
  }
  
  .security-footer {
    flex-direction: column;
    gap: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Advertisement/Stripe/stripe_payment.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gFAAgF;AAClF;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF","sourcesContent":["/* stripe_payment.css */\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.payment-page-wrapper {\r\n  min-height: 100vh;\r\n  background: #f5f5f5;\r\n  padding: 30px 20px;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\r\n}\r\n\r\n.payment-container-main {\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.payment-header {\r\n  background: white;\r\n  padding: 20px 30px;\r\n  border-radius: 8px;\r\n  margin-bottom: 30px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.payment-header h1 {\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  margin: 0;\r\n}\r\n\r\n.payment-content-wrapper {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1.5fr;\r\n  gap: 25px;\r\n  align-items: start;\r\n}\r\n\r\n/* Order Summary Card */\r\n.order-summary-section {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 30px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\r\n  position: sticky;\r\n  top: 20px;\r\n}\r\n\r\n.order-summary-section h2 {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  margin-bottom: 20px;\r\n  padding-bottom: 15px;\r\n  border-bottom: 2px solid #f5f5f5;\r\n}\r\n\r\n.ad-info-box {\r\n  background: #fff8f0;\r\n  border: 1px solid #ffe4cc;\r\n  border-radius: 6px;\r\n  padding: 20px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.ad-info-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.ad-info-row:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.info-label {\r\n  font-size: 14px;\r\n  color: #666;\r\n  font-weight: 500;\r\n}\r\n\r\n.info-value {\r\n  font-size: 15px;\r\n  color: #333;\r\n  font-weight: 600;\r\n}\r\n\r\n.price-display-box {\r\n  background: linear-gradient(135deg, #ff6b00 0%, #ff8c3a 100%);\r\n  border-radius: 6px;\r\n  padding: 25px;\r\n  text-align: center;\r\n  margin-top: 20px;\r\n  color: white;\r\n}\r\n\r\n.price-label-text {\r\n  font-size: 14px;\r\n  opacity: 0.95;\r\n  margin-bottom: 8px;\r\n  font-weight: 500;\r\n}\r\n\r\n.price-amount-display {\r\n  font-size: 42px;\r\n  font-weight: 700;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.price-subtext {\r\n  font-size: 13px;\r\n  opacity: 0.9;\r\n}\r\n\r\n.divider-line {\r\n  height: 1px;\r\n  background: #e5e5e5;\r\n  margin: 20px 0;\r\n}\r\n\r\n.user-info-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px 0;\r\n}\r\n\r\n.user-info-label {\r\n  font-size: 14px;\r\n  color: #666;\r\n  font-weight: 500;\r\n}\r\n\r\n.user-info-value {\r\n  font-size: 14px;\r\n  color: #333;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Payment Form Card */\r\n.payment-form-section {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 35px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.payment-form-section h3 {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  margin-bottom: 25px;\r\n  padding-bottom: 15px;\r\n  border-bottom: 2px solid #f5f5f5;\r\n}\r\n\r\n.secure-payment-badge {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 15px;\r\n  background: #f0fdf4;\r\n  border: 1px solid #d1fae5;\r\n  border-radius: 6px;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.secure-payment-badge svg {\r\n  width: 24px;\r\n  height: 24px;\r\n  fill: #10b981;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.secure-payment-badge p {\r\n  font-size: 13px;\r\n  color: #047857;\r\n  margin: 0;\r\n  line-height: 1.5;\r\n}\r\n\r\n.stripe-element-container {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.error-message-box {\r\n  margin-top: 15px;\r\n  padding: 12px 15px;\r\n  background: #fef2f2;\r\n  border: 1px solid #fecaca;\r\n  border-radius: 6px;\r\n  color: #dc2626;\r\n  font-size: 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.pay-button-submit {\r\n  width: 100%;\r\n  background: linear-gradient(135deg, #ff6b00 0%, #ff8c3a 100%);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 16px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  margin-top: 25px;\r\n}\r\n\r\n.pay-button-submit:hover:not(:disabled) {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 6px 20px rgba(255, 107, 0, 0.35);\r\n}\r\n\r\n.pay-button-submit:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.pay-button-submit .button-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n  fill: white;\r\n}\r\n\r\n.security-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n  gap: 20px;\r\n  margin-top: 20px;\r\n  padding-top: 20px;\r\n  border-top: 1px solid #e5e5e5;\r\n}\r\n\r\n.security-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 12px;\r\n  color: #666;\r\n}\r\n\r\n.security-item svg {\r\n  width: 16px;\r\n  height: 16px;\r\n  fill: #10b981;\r\n}\r\n\r\n.loading-spinner-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 350px;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 1024px) {\r\n  .payment-content-wrapper {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .order-summary-section {\r\n    position: static;\r\n  }\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .payment-page-wrapper {\r\n    padding: 20px 10px;\r\n  }\r\n  \r\n  .payment-header {\r\n    padding: 15px 20px;\r\n  }\r\n  \r\n  .payment-header h1 {\r\n    font-size: 20px;\r\n  }\r\n  \r\n  .order-summary-section,\r\n  .payment-form-section {\r\n    padding: 20px;\r\n  }\r\n  \r\n  .price-amount-display {\r\n    font-size: 36px;\r\n  }\r\n  \r\n  .security-footer {\r\n    flex-direction: column;\r\n    gap: 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
